import React from 'react';
import backIcon from '../assets/icons/arrow-left.png';
import {useLocation, useNavigate} from "react-router-dom";

function BackButton() {
    const navigate = useNavigate();
    const location = useLocation();

    function goBackHandler() {
        if (location.state?.prevPath?.length) {
            navigate(location.state?.prevPath)
        } else {
            navigate(-1);
        }
    }

    return (
        <button className="border border-white bg-blue p-2.5 rounded-full" onClick={goBackHandler}>
            <img src={backIcon} width={24} height={24} alt="Go Back" />
        </button>
    );
};

export default BackButton;
